export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'

export const LOADED = 'LOADED'
export const LOADING = 'LOADING'

export const LOAD_SERVICES = 'LOAD_SERVICES'
export const SELECT_SERVICE = 'SELECT_SERVICE'
export const DESELECT_SERVICE = 'DESELECT_SERVICE'
export const ADD_SERVICE = 'ADD_SERVICE'
export const REMOVE_SERVICE = 'REMOVE_SERVICE'

export const SET_PAGE = 'SET_PAGE'
export const NEXT_PAGE = 'NEXT_PAGE'
export const PREVIOUS_PAGE = 'PREVIOUS_PAGE'
export const MODIFY_CONTACT_DETAILS = 'MODIFY_CONTACT_DETAILS'

export const SET_BOOKING_DATE = 'SET_BOOKING_DATE'
export const SET_BOOKING_TIME = 'SET_BOOKING_TIME'
export const RESET_BOOKING_TIME = 'RESET_BOOKING_TIME'

export const CLEAR_CART = 'CLEAR_CART'
export const CART_ERROR = 'CART_ERROR'